import { getApp, getApps, initializeApp } from 'firebase/app';

const { vapidKey, ...firebaseConfig } = window.firebaseConfig;

const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

export { vapidKey };
export default firebaseApp;
